import { render, staticRenderFns } from "./MA10.vue?vue&type=template&id=d789b53a&scoped=true&"
import script from "./MA10.vue?vue&type=script&lang=js&"
export * from "./MA10.vue?vue&type=script&lang=js&"
import style0 from "./MA10.vue?vue&type=style&index=0&id=d789b53a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d789b53a",
  null
  
)

export default component.exports